import React, { Component } from 'react';
import classNames from 'classnames';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Checkout from './Checkout';
import TargetTab from './TargetTab';
import PaymentTab from './PaymentTab';
// import ScheduleTab from './ScheduleTab';

import PushPreview from './previews/PushPreview';

const Content = ({
  state,
  handleChange,
}) => (
  <div>
    <div>
      <input className="input" type="text" 
        name="title"
        placeholder="Title"
        value={state.title}
        onChange={handleChange}/>
      <textarea className="textarea" rows="8" maxLength="150"
        name="message"
        placeholder="Message"
        value={state.message}
        onChange={handleChange}/>
      { state.message && <div className="sub">{ state.message.length } / 150</div> }
      <input className="input" type="text" 
        name="url"
        placeholder="URL"
        value={state.url}
        onChange={handleChange}/>
    </div>
  </div>
)

class PushCampaign extends Component {
  state = {
    title: '',
    message: '',
    url: '',
    country: '',
    city: '',
    segment: '',
    orderName: '',
    sendDate: '',
    eventDate: '',
    checkout: false,
  }

  handleChange = (ev) => {
    const name = ev.target.name;
    const value = ev.target.value;

    this.setState({ [name]: value })
  }

  showCheckout = (ev) => {
    this.setState({ checkout: !this.state.checkout })
  }

  render() {
    const campaign__sidebar = classNames('campaign__sidebar', { 'campaign__sidebar--disable': this.state.checkout });
    return (
      <div className="campaign">
        <div className={campaign__sidebar}>
          <Tabs>
            <TabList className="campaign__tabs">
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">PUSH Campaign</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Target</Tab>
              <Tab className="campaign__tab"
                selectedClassName="campaign__tab--selected">Order</Tab>
            </TabList>
            <TabPanel>
              <Content 
                state={this.state}
                handleChange={this.handleChange} />
            </TabPanel>
            <TabPanel>
              <TargetTab
                state={this.state}
                handleChange={this.handleChange} />
            </TabPanel>
            <TabPanel>
              <PaymentTab
                state={this.state}
                handleChange={this.handleChange} 
                showCheckout={this.showCheckout} />
            </TabPanel>
          </Tabs>
          {/* <div className="campaign__buttons">
            <button className="button" onClick={this.props.hideModal}>Close</button>
            <button className="button">Save</button>
          </div> */}
        </div>
        <div className="campaign__preview">
          { this.state.checkout ?
            <Checkout /> :
            <PushPreview state={this.state} />
          }
        </div>
      </div>
    )
  }
}

export default PushCampaign


// WEBPACK FOOTER //
// ./src/components/campaigns/PushCampaign.js